/** The policy-level limit as the underwriter header names it. One copy: the
 *  header renders it and the Moo snapshot tells the agent the same name. */
export const AGGREGATE_LIMIT_LABEL = 'Aggregate Limit of Liability';

/**
 * What a suite part's header calls its controls, by field. One copy: the header
 * renders them, the Moo snapshot tells the agent the same names, and the draft
 * names a staged change with them.
 *
 * The header renders the retention through `t('retention')` instead, because
 * that label is localised ("Excess" in en-GB and en-AU); the agent and the row
 * descriptions read this one.
 */
export const PART_CONTROL_LABELS: Readonly<Record<string, string>> = {
  limit: 'Limit',
  deductible: 'Retention',
  priorOrPendingDate: 'Pending or Prior Date',
  crimeClassCode: 'Crime Class Code',
};

/**
 * One part control as the agent and the draft name it: the part, then the
 * control ("Directors and Officers Limit"). Two parts both have a Limit, so the
 * part is what tells them apart.
 */
export const partControlLabel = (
  partName: string,
  controlLabel: string
): string => `${partName} ${controlLabel}`;
